// Oberflächen-Manifest des KI-Assistenten: Er hat keine eigene Seite – das Panel hängt über den Slot
// `assistantPanel` im App-Rahmen (rechts angedockt, überlagernd oder als Blatt auf dem Telefon, ⌘J).
// Kein Recht am Slot: Auch wer den Assistenten nicht nutzen darf, soll sehen, warum (GET /api/assistant/config
// nennt Grund und Satz). Wird von scripts/gen-registry.ts in Node geladen: nur lazy-Importe.
import { defineWebModule } from '@web/module'

export default defineWebModule({
  id: 'assistant',
  assistantPanel: { lazy: () => import('./AssistantPanel') },
})
